<template>
    <div class="accordion">
        <ul>
            <accordion v-for="(item, key) in options" :key="key" :item="item"></accordion>
        </ul>
    </div>
</template>

<script>
  import Accordion from '@/components/items/Accordion.vue';
  export default {
    name: 'options',
    props: ['options'],
    components: {
      Accordion
    },
    data () {
      return {

      }
    },
    methods: {
      toggle (item) {
        if (item.open === undefined) {
          item.open = false
        }
        item.open = !item.open
      }
    }
  }
</script>

<style lang="scss">
    .accordion {
        max-width: 1130px;
        margin: auto;

        ul {
            width: 100%;
            li {
                border-bottom: 1px solid #919191;
                &:first-child {
                    border-top: 1px solid #919191;
                }
                .accordion-title {
                    font-family: $font-bold;
                    cursor: pointer;
                    padding-right: 40px;
                    padding-top: 12px;
                    padding-bottom: 12px;
                }
                .accordion-content {
                    line-height: 24px;
                    margin-bottom: 15px;
                }
            }
        }
    }
</style>
